import type { RelativeLookback } from "../../utils/dates"

export const DEFAULT_GDELT_DATE_RANGE: RelativeLookback = {
  lookbackUnit: "hours",
  lookbackValue: 24,
}

/** 2 weeks — matches shortest NWSS preset; CDC detections are typically 1–2 weeks behind today. */
export const DEFAULT_NWSS_DATE_RANGE: RelativeLookback = {
  lookbackUnit: "days",
  lookbackValue: 14,
}
